var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.252 5.5008C12.252 4.30711 11.7778 3.16232 10.9337 2.31825C10.0897 1.47419 8.94488 1 7.7512 1C6.55751 1 5.41272 1.47419 4.56865 2.31825C3.72459 3.16232 3.2504 4.30711 3.2504 5.5008C3.2504 10.7517 1 12.252 1 12.252H14.5024C14.5024 12.252 12.252 10.7517 12.252 5.5008Z",
    stroke: "#44585F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04907 15.2525C8.91719 15.4799 8.7279 15.6686 8.50015 15.7998C8.27239 15.931 8.01417 16 7.75134 16C7.48851 16 7.23029 15.931 7.00254 15.7998C6.77479 15.6686 6.58549 15.4799 6.45361 15.2525",
    stroke: "#44585F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.953cbb260ab0fa65e7c15721d6c9c4c3.svg";
export { ForwardRef as ReactComponent };